import { mediaCategories } from '../../../../../../constants/mediaOrders'

export const transformResponseValueToLabel = responseValue => {
  // Find the category object where the value matches the response value
  const category = mediaCategories.find(category => category.value === responseValue)

  // Return the label if found, otherwise return the response value as is
  return category ? category.label : responseValue
}
